import { render, staticRenderFns } from "./ShenPiChuChai.vue?vue&type=template&id=4d361768&scoped=true&"
import script from "./ShenPiChuChai.vue?vue&type=script&lang=js&"
export * from "./ShenPiChuChai.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiChuChai.vue?vue&type=style&index=0&id=4d361768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d361768",
  null
  
)

export default component.exports